"use client";

var _excluded = ["innerRef", "size"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import NibLogo, { NibLogomark, NibWordmark, NibArrow } from "./brands/nib";
import NibLegacyLogo from "./brands/nibLegacy";
import NibThrive from "./brands/nibThrive";
import GuLogo from "./brands/gu";
import QantasLogo from "./brands/qantas";
import SuncorpLogo from "./brands/suncorp";
import ApiaLogo from "./brands/apia";
import AamiLogo from "./brands/aami";
import NsiLogo from "./brands/nsi";
import CotaLogo from "./brands/cota";
import TalLogo from "./brands/tal";
import ImanLogo from "./brands/iman";
import FoundationLogo from "./brands/foundation";
import IngLogo from "./brands/ing";
import PricelineLogo from "./brands/priceline";
import WorldNomadsLogo from "./brands/worldNomads";
import AustralianSeniorsLogo from "./brands/australianSeniors";
import RealLogo from "./brands/real";
import { sizePropType } from "./utils";
import AanzLogo from "./brands/aanz";
import EdiLogo from "./brands/edi";
import TidLogo from "./brands/tid"; // eslint-disable-next-line @typescript-eslint/ban-types

var Logo = function Logo(props) {
  var themeContext = useContext(ThemeContext);

  var innerRef = props.innerRef,
      size = props.size,
      otherProps = _objectWithoutProperties(props, _excluded); // We use the theme selector to look at which brand the theme is using and then render the appropriate logo from that.
  // No need to manually pass in a prop :)


  switch (themeContext.id) {
    case "ing":
      return /*#__PURE__*/React.createElement(IngLogo, _extends({
        size: size
      }, otherProps));

    case "qantas":
      return /*#__PURE__*/React.createElement(QantasLogo, _extends({
        size: size
      }, otherProps));

    case "gu":
      return /*#__PURE__*/React.createElement(GuLogo, _extends({
        size: size
      }, otherProps));

    case "suncorp":
      return /*#__PURE__*/React.createElement(SuncorpLogo, _extends({
        size: size
      }, otherProps));

    case "apia":
      return /*#__PURE__*/React.createElement(ApiaLogo, _extends({
        size: size
      }, otherProps));

    case "aami":
      return /*#__PURE__*/React.createElement(AamiLogo, _extends({
        size: size
      }, otherProps));

    case "nsi":
      return /*#__PURE__*/React.createElement(NsiLogo, _extends({
        size: size
      }, otherProps));

    case "cota":
      return /*#__PURE__*/React.createElement(CotaLogo, _extends({
        size: size
      }, otherProps));

    case "tal":
      return /*#__PURE__*/React.createElement(TalLogo, _extends({
        size: size
      }, otherProps));

    case "iman":
      return /*#__PURE__*/React.createElement(ImanLogo, _extends({
        size: size
      }, otherProps));

    case "foundation":
      return /*#__PURE__*/React.createElement(FoundationLogo, _extends({
        size: size
      }, otherProps));

    case "priceline":
      return /*#__PURE__*/React.createElement(PricelineLogo, _extends({
        size: size
      }, otherProps));

    case "worldNomads":
      return /*#__PURE__*/React.createElement(WorldNomadsLogo, _extends({
        size: size
      }, otherProps));

    case "nibLegacy":
      return /*#__PURE__*/React.createElement(NibLegacyLogo, _extends({
        size: size
      }, otherProps));

    case "australianSeniors":
      return /*#__PURE__*/React.createElement(AustralianSeniorsLogo, _extends({
        size: size
      }, otherProps));

    case "real":
      return /*#__PURE__*/React.createElement(RealLogo, _extends({
        size: size
      }, otherProps));

    case "aanz":
      return /*#__PURE__*/React.createElement(AanzLogo, _extends({
        size: size
      }, otherProps));

    case "edi":
      return /*#__PURE__*/React.createElement(EdiLogo, _extends({
        size: size
      }, otherProps));

    case "tid":
      return /*#__PURE__*/React.createElement(TidLogo, _extends({
        size: size
      }, otherProps));

    case "nib":
    default:
      return /*#__PURE__*/React.createElement(NibLogo, _extends({
        size: size
      }, otherProps));
  }
};

Logo.displayName = "Logo";
Logo.defaultProps = {
  invert: false,
  size: "small"
};
export { NibLogo, NibLogomark, NibWordmark, NibArrow, NibLegacyLogo, NibThrive, GuLogo, QantasLogo, SuncorpLogo, ApiaLogo, TalLogo, ImanLogo, FoundationLogo, PricelineLogo, WorldNomadsLogo, NsiLogo, CotaLogo, AustralianSeniorsLogo, RealLogo, AanzLogo, EdiLogo };
export default Logo;